/**
 * 创建人：D
 * 创建时间：2019-07-12
 * 描述：获取用户信息
 * 更新记录: 
 */

import { Injectable } from '@angular/core';
import { SwJwtService } from '../sw-jwt.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { SwHttpClientService } from '../sw-http-client.service';
import { SystemIdService } from './system-id.service';


/**
 * 获取当前登入人 用户信息 
 */
@Injectable()
export class GetUserModelService {

  /**
   * @ignore
   */
  constructor(
    private jwt: SwJwtService,  //本地缓存服务
    private router: Router,  //路由
    private _http: SwHttpClientService,
    private systemId:SystemIdService
  ) { }

  flag=true;//开关，指示当前是否在请求中
  /**
   * 获取用户信息
   * @returns user
   */
  getUser() {
    let switchUser=this.getQueryVariable("switchUser");
    if(environment.enableSsoLogin && switchUser){
      //如果switchUser存在并且启用了sso登录，表示现在要清除用户信息。清缓存，重新登录
      this.jwt.clear();
    }
    let user = JSON.parse(this.jwt.getToken("User"));
    if (user != null) {
      return user;
    } else {
        //用户信息为空，在这判断是否跳转登录页还是跳转soo登录
        if(environment.enableSsoLogin){
          let code=this.getQueryVariable("code");
          let returnUrl=this.getQueryVariable("url");//回调地址
          let returnParam=this.getQueryVariable("params");//回调地址携带的参数对象
          this.jwt.clear();
          if(code){
            if(returnUrl){
                //如果存在回调地址，则先登录再跳到回调地址，否则跳到登录地址处理
                this.router.navigate(['login'],{
                  queryParams: { code: code,url:returnUrl,params:returnParam}
                });
            }else{
              this.router.navigate(['login'],{
                queryParams: { code: code}
              });
            }   
          }else{
            //window.location.href=environment.defaultAddress;
          }
        }else{
          this.router.navigate(['login']);
          this.jwt.clear();
        }
      }
  }

  browserType:string
  
  getBrowserInfo(){
    //判断浏览器内核
    var ua = navigator.userAgent.toLocaleLowerCase();
    this.browserType = null;
    if(ua.match(/msie/) != null || ua.match(/trident/) != null){
      this.browserType = "IE";
    } else if(ua.match(/firefox/) != null){
      this.browserType = "火狐";
    } else if(ua.match(/ubrowser/) != null){
      this.browserType = "UC";
    } else if(ua.match(/opera/) != null){
      this.browserType = "欧朋";
    } else if(ua.match(/bidubrowser/) != null){
      this.browserType = "百度";
    } else if(ua.match(/metasr/) != null){
      this.browserType = "搜狗";
    } else if(ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null){
      this.browserType = "QQ";
    } else if(ua.match(/maxthon/) != null){
      this.browserType = "遨游";
    } else if(ua.match(/chrome/) != null){
      var is360 = this.mime("type","application/vnd.chromium.remoting-viewer");
      if(is360){
        this.browserType = "360";
      } else {
        this.browserType = "谷歌";
      }
    } else if(ua.match(/safari/) != null){
      this.browserType = "safari";
    }
    console.log('browserType',this.browserType);
    
  };

  mime(option,value){
    var mimeTypes = navigator.mimeTypes;
    for (const mt in mimeTypes) {
      if (mimeTypes[mt][option] === value) {
        return true;
        
      }
    }
    return false;
  };
  
   getQueryVariable(variable)
    {
      try{
        var query = window.location.hash.split("?")[1];
        var vars = query.split("&");
        for (var i=0;i<vars.length;i++) {
                var pair = vars[i].split("=");
                if(pair[0] == variable){return pair[1];}
        }
        return(false);
      }catch{
        return(false);
      }     
    }

  /**
   * 写入用户信息
   * @param model  用户的基础数据
   */
  setUser(model: any) {
    this.jwt.setToKen("User", JSON.stringify(model));
  }
 //获取用户常用头像
 getUserImage(){
  let img = ['assets/Images/userphoto/man-1.png','assets/Images/userphoto/man-2.png','assets/Images/userphoto/man-3.png','assets/Images/userphoto/man-4.png','assets/Images/userphoto/man-5.png',
            'assets/Images/userphoto/woman-1.png','assets/Images/userphoto/woman-2.png','assets/Images/userphoto/woman-3.png','assets/Images/userphoto/woman-4.png','assets/Images/userphoto/woman-5.png']
  if(img){
     return  img
  }
 }
}
